<template>
	<div>
		<div class="row mb-3">
			<div class="col-12 col-md-6 col-lg-8">
				<h1><em class="fas fa-bus-alt"></em> My Seating Plans</h1>
			</div>
			<div class="col-12 col-md-6 col-lg-4 text-right">
				<a :href="NSTS_CONFIG['api_server'] + '/runs/pdf/all'" class="btn btn-success mx-1" target="_blank"><em class="fas fa-file-pdf"></em> Download All</a>
				<a :href="NSTS_CONFIG['api_server'] + '/runs/pdf/changed'" class="btn btn-success mx-1" target="_blank"><em class="fas fa-file-pdf"></em> Download Changes</a>
			</div>
		</div>

		<div class="row mb-3" v-show="runs.length > 0">
			<div class="col-12 col-lg-2">
				<label for="filter_school_id" class="font-weight-bold">School</label>
				<div v-if="schools.length == 1">{{schools[0].school_name}}</div>

				<select class="form-control custom-select custom-select-sm" v-model="filters.school_id" id="filter_school_id" v-if="schools.length > 1" @change="saveFilters()">
					<option :value="null">All Schools</option>
					<option v-for="s in schools" :key="s.school_id" :value="s.school_id">{{s.school_name}}</option>
				</select>
			</div>
			<div class="col-12 col-lg-2">
				<label for="filter_operator_id" class="font-weight-bold">Operator</label>
				<div v-if="operators.length == 1">{{operators[0].operator_name}}</div>
				<select class="form-control custom-select custom-select-sm" v-model="filters.operator_id" id="filter_operator_id" v-if="operators.length > 1" @change="saveFilters()">
					<option :value="null">All Operators</option>
					<option v-for="o in operators" :key="o.operator_id" :value="o.operator_id">{{o.operator_name}}</option>
				</select>
			</div>
			<div class="col-12 col-lg-2">
				<label for="filter_q" class="font-weight-bold">Route or Run ID</label>
				<input type="search" class="form-control form-control-sm" v-model="filters.q" id="filter_q" placeholder="###" @change="saveFilters()" />
			</div>
			<div class="col-12 col-lg-2 text-center">
				<label for="filter_unseated_students"><span class="badge badge-danger"><em class="fas fa-user-graduate"></em> Unseated Students</span></label>
				<div class="custom-control custom-switch">
					<input type="checkbox" class="custom-control-input" id="filter_unseated_students" v-model="filters.unseated_students" @change="saveFilters()">
					<label class="custom-control-label" for="filter_unseated_students"></label>
				</div>
			</div>
			<div class="col-12 col-lg-2 text-center">
				<label for="filter_new_students"><span class="badge badge-warning"><em class="fas fa-user-graduate"></em> New Students</span></label>
				<div class="custom-control custom-switch">
					<input type="checkbox" class="custom-control-input" id="filter_new_students" v-model="filters.new_students" @change="saveFilters()">
					<label class="custom-control-label" for="filter_new_students"></label>
				</div>
			</div>
			<div class="col-12 col-lg-2 text-center">
				<label for="filter_new_plan"><span class="badge badge-success"><em class="fas fa-file-pdf"></em> Changes</span></label>
				<div class="custom-control custom-switch">
					<input type="checkbox" class="custom-control-input" id="filter_new_plan" v-model="filters.new_plan" @change="saveFilters()">
					<label class="custom-control-label" for="filter_new_plan"></label>
				</div>
			</div>
		</div>

		<div class="alert alert-info text-center" v-show="runs.length == 0 && !loading"><em class="fas fa-info-circle"></em> You currently have no seating plans available.</div>
		<div class="alert alert-info text-center" v-show="runs.length > 0 && filteredRunsTotal == 0 && !loading"><em class="fas fa-info-circle"></em> No seating plans matched your search.</div>

		<div class="list-group mb-3" v-show="filteredRunsTotal > 0">
			<router-link :to="'seating_plan/' + r.run_id" v-for="r in filteredRuns" :key="r.run_id" class="list-group-item list-group-item-action">
				<div class="row">
					<div class="col-3">
						<em :class="{'fas fa-bus-alt': true}"></em> <span v-show="NSTS_CONFIG['show_route_id']">{{r.route_id}}: </span>{{r.run_id}}<span v-show="NSTS_CONFIG['show_vehicle_class']"> ({{r.vehicle_desc}})</span>
					</div>
					<div class="col-3" v-show="!NSTS_CONFIG['show_run_path']"><!-- spacer --></div>
					<div class="col-3" v-show="NSTS_CONFIG['show_run_path'] && (runDir(r) == 'PU' || runDir(r) == '??')">
						<span><em class="fas fa-fw fa-home"></em><em class="fas fa-fw fa-caret-right"></em></span>
						<span v-show="r.transfer_school_id">{{r.transfer_school_id}}<em class="fas fa-fw fa-caret-right"></em></span>
						<span v-show="r.transfer2_school_id">{{r.transfer2_school_id}}<em class="fas fa-fw fa-caret-right"></em></span>
						<span v-show="r.transfer3_school_id">{{r.transfer3_school_id}}<em class="fas fa-fw fa-caret-right"></em></span>
						<span>{{r.school_id}}</span>
					</div>
					<div class="col-3" v-show="NSTS_CONFIG['show_run_path'] && runDir(r) == 'DO'">
						<span>{{r.school_id}}<em class="fas fa-fw fa-caret-right"></em></span>
						<span v-show="r.transfer_school_id">{{r.transfer_school_id}}<em class="fas fa-fw fa-caret-right"></em></span>
						<span v-show="r.transfer2_school_id">{{r.transfer2_school_id}}<em class="fas fa-fw fa-caret-right"></em></span>
						<span v-show="r.transfer3_school_id">{{r.transfer3_school_id}}<em class="fas fa-fw fa-caret-right"></em></span>
						<span><em class="fas fa-fw fa-home"></em></span>
					</div>
					<div class="col-3 text-right">{{r.updated | shortDate}} by {{r.updated_by}}</div>
					<div class="col-3 text-right">
						<span v-show="r.unseated_students > 0" class="badge badge-danger mx-1" title="This run has unseated students."><em class="fas fa-user-graduate"></em> {{r.unseated_students}} UNSEATED</span>
						<span v-show="r.new_students > 0" class="badge badge-warning mx-1" title="This run has new students that were placed in empty seats, not necessarily where they should sit."><em class="fas fa-user-graduate"></em> {{r.new_students}} NEW</span>
						<span v-show="r.dirty == 1" class="badge badge-success mx-1" title="Changes have been made since your last download."><em class="fas fa-file-pdf"></em> CHANGES</span>
						<span v-show="r.autopilot == 1" class="text-success mx-1" title="This run is on autopilot (no manual changes have been made)."><em class="fas fa-fw fa-robot"></em></span>
						<span v-show="r.autopilot == 0" class="text-success mx-1" title="This has manual changes."><em class="fas fa-fw fa-user-tie"></em></span>
					</div>
				</div>
			</router-link>
		</div>

		<div class="row mb-3" v-show="pages > 1">
			<nav aria-label="Next / previous pages" class="mx-auto">
				<ul class="pagination">
					<li class="page-item" :class="{'invisible': page == 1}"><button class="page-link" @click="page--"><em class="fas fa-chevron-left"></em> Previous {{NSTS_CONFIG["per_page"]}}</button></li>
					<li class="page-item" v-for="p in pageArray" :key="p"><button class="page-link" :class="{'font-weight-bold': page == p}" @click="page = p">{{p}}</button></li>
					<li class="page-item" :class="{'invisible': page == pages}"><button class="page-link" @click="page++">Next {{NSTS_CONFIG["per_page"]}} <em class="fas fa-chevron-right"></em></button></li>
				</ul>
			</nav>
		</div>
	</div>
</template>

<script>
export default
{
	name: 'Home',
	data: function()
	{
		return {
			runs: [],
			loading: true,
			filters: {q: "", school_id: null, operator_id: null, unseated_students: 0, new_students: 0, new_plan: 0},
			page: 1
		}
	},
	mounted: function()
	{
		this.restoreFilters();
		this.loadRuns();
	},
	computed:
	{
		pages: function()
		{
			return Math.ceil(this.filteredRunsTotal / this.NSTS_CONFIG["per_page"]);
		},
		pageArray: function()
		{
			var x = new Array();

			for(var i=1; i<=this.pages; i++)
			{
				x.push(i);
			}

			return x;
		},
		offset: function()
		{
			return (this.page - 1) * this.NSTS_CONFIG["per_page"];
		},
		limit: function()
		{
			return this.NSTS_CONFIG["per_page"];
		},
		filteredRuns: function()
		{
			return this.runs.filter(this._runFilter).splice(this.offset, this.limit);
		},
		filteredRunsTotal: function()
		{
			return this.runs.filter(this._runFilter).length;
		},
		schools: function()
		{
			var schools = [];
			var school_flags = {};

			for(var i=0; i<this.runs.length; i++)
			{
				schools.push({school_id: this.runs[i].school_id, school_name: this.runs[i].school_name});
			}

			// Remove duplicates.
			schools = schools.filter(function(value)
				{
					if(school_flags[value.school_id])
					{
						return false;
					}
					school_flags[value.school_id] = true;
					return true;
				});

			return schools.sort(function(a, b)
				{
					if(a["school_name"] < b["school_name"])
					{
						return -1;
					}
					else if(a["school_name"] > b["school_name"])
					{
						return 1;
					}
					else
					{
						return 0;
					}
				});
		},
		operators: function()
		{
			var operators = [];
			var operator_flags = {};

			for(var i=0; i<this.runs.length; i++)
			{
				operators.push({operator_id: this.runs[i].operator_id, operator_name: this.runs[i].operator_name});
			}

			// Remove duplicates.
			operators = operators.filter(function(value)
				{
					if(operator_flags[value.operator_id])
					{
						return false;
					}
					operator_flags[value.operator_id] = true;
					return true;
				});


			return operators.sort(function(a, b)
				{
					if(a["operator_name"] < b["operator_name"])
					{
						return -1;
					}
					else if(a["operator_name"] > b["operator_name"])
					{
						return 1;
					}
					else
					{
						return 0;
					}
				});
		}
	},
	methods:
	{
		loadRuns: function()
		{
			var vm = this;
			vm.loading = true;
			vm.startLoading();

			this.CORS("GET", "/runs", null,
			function(response)
			{
				vm.runs = response;
				vm.loading = false;
				vm.stopLoading();
			}, function()
			{
				// vm.showError("Error Loading Seating Plans", response.responseText, true, null);
				vm.loading = false;
				vm.stopLoading();
			})
		},
		saveFilters: function()
		{
			if(this.filters["q"] == null || this.filters["q"] == "" || this.filters["q"] == "null")
			{
				localStorage.removeItem("q");
			}
			else
			{
				localStorage.setItem("q", String(this.filters["q"]));
			}
			if(this.filters["school_id"] == null || this.filters["school_id"] == "null")
			{
				localStorage.removeItem("school_id");
			}
			else
			{
				localStorage.setItem("school_id", String(this.filters["school_id"]));
			}
			if(this.filters["operator_id"] == null || this.filters["operator_id"] == "null")
			{
				localStorage.removeItem("operator_id");
			}
			else
			{
				localStorage.setItem("operator_id", String(this.filters["operator_id"]));
			}
			localStorage.setItem("unseated_students", (this.filters["unseated_students"]) == 1 ? 1 : 0);
			localStorage.setItem("new_students", (this.filters["new_students"]) == 1 ? 1 : 0);
			localStorage.setItem("new_plan", (this.filters["new_plan"]) == 1 ? 1 : 0);
		},
		restoreFilters: function()
		{
			if(localStorage.getItem("q") != null)
			{
				this.filters["q"] = String(localStorage.getItem("q"));
			}
			if(localStorage.getItem("school_id") != null)
			{
				this.filters["school_id"] = String(localStorage.getItem("school_id"));
			}
			if(localStorage.getItem("operator_id") != null)
			{
				this.filters["operator_id"] = String(localStorage.getItem("operator_id"));
			}
			this.filters["unseated_students"] = (localStorage.getItem("unseated_students") == 1 ? 1 : 0);
			this.filters["new_students"] = (localStorage.getItem("new_students") == 1 ? 1 : 0);
			this.filters["new_plan"] = (localStorage.getItem("new_plan") == 1 ? 1 : 0);
		},
		_runFilter: function(run)
		{
			var match = true;
			var tag_match = true;
			var ids;
			var found;
			var i;

			// Tags match by default, unless one is checked.
			if(this.filters.unseated_students == 1 || this.filters.new_students == 1 | this.filters.new_plan == 1)
			{
				tag_match = false;
			}

			if(this.filters.q != "")
			{
				var q = String(this.filters.q);
				q = q.replace(/\(/g, '\\(')
				q = q.replace(/\)/g, '\\)')
				q = q.replace(/\+/g, '\\+')

				var re = new RegExp(q, "i");

				match = match && (re.test(run.route_id) || re.test(run.run_id));
			}
			if(this.filters.school_id != null)
			{
				ids = run.school_ids.split(",");
				found = false;

				for(i=0; i<ids.length; i++)
				{
					if(ids[i] == this.filters.school_id)
					{
						found = true;
						break;
					}
				}

				match = match && (run.school_id == this.filters.school_id || found);
			}
			if(this.filters.operator_id != null)
			{
				ids = run.operator_ids.split(",");
				found = false;

				for(i=0; i<ids.length; i++)
				{
					if(ids[i] == this.filters.operator_id)
					{
						found = true;
						break;
					}
				}

				match = match && (run.operator_id == this.filters.operator_id || found);
			}
			if(this.filters.unseated_students == 1)
			{
				tag_match = tag_match || run.unseated_students > 0;
			}
			if(this.filters.new_students == 1)
			{
				tag_match = tag_match || run.new_students > 0;
			}
			if(this.filters.new_plan == 1)
			{
				tag_match = tag_match || run.dirty == 1;
			}

			return (match && tag_match);
		}
	}
}
</script>
